// Define an interface for the slider settings.
// Static slider settings for products.
export const productsSliderSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};
// Recipe module slider settings with configurable breakpoints.
export const recipeModuleSliderSettings = (screenLG = 3, screenMD = 3, screenSM = 2, screenXS = 1) => {
    return {
        slidesToShow: screenLG,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: screenLG,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: screenMD,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: screenSM,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: 1,
                },
            },
        ],
    };
};
// Recipe type module slider settings with configurable slidesToScroll.
export const recipeTypeModuleSliderSettings = (screenLG = 3, screenMD = 2, screenSM = 2, screenXS = 1) => {
    return {
        slidesToShow: screenLG,
        slidesToScroll: screenLG,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: screenLG,
                    slidesToScroll: screenLG,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: screenMD,
                    slidesToScroll: screenMD,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: screenSM,
                    slidesToScroll: screenSM,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: screenXS,
                },
            },
        ],
    };
};
// Meal size module slider settings.
export const mealSizeModuleSliderSettings = (screenLG = 3, screenMD = 2, screenSM = 2, screenXS = 1) => {
    return {
        slidesToShow: screenLG,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: screenLG,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: screenMD,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: screenSM,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: 1,
                },
            },
        ],
    };
};
// Day filter slider settings.
export const setDayFilterSliderSettings = (theme, screenLG = 3, screenMD = 2, screenSM = 2, screenXS = 1) => {
    return {
        slidesToShow: screenLG,
        slidesToScroll: screenLG,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: theme.breakpoints.values.md,
                settings: {
                    slidesToShow: screenMD,
                    slidesToScroll: screenMD,
                },
            },
            {
                breakpoint: theme.breakpoints.values.sm,
                settings: {
                    slidesToShow: screenSM,
                    slidesToScroll: screenSM,
                },
            },
            {
                breakpoint: theme.breakpoints.values.xs,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: screenXS,
                },
            },
            {
                breakpoint: theme.breakpoints.values.xx,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: screenXS,
                },
            },
        ],
    };
};
// Default button slider settings.
export const DEFAULT_BUTTON_SLIDER_SETTINGS = (screenLG = 4, screenMD = 3, screenSM = 2, screenXS = 2) => {
    return {
        slidesToShow: screenLG,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: screenLG,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: screenMD,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: screenSM,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: screenXS,
                    slidesToScroll: 1,
                },
            },
        ],
    };
};
